export const home = {
    path: '/',
    name: 'home',
    component: () => import('./'),
    meta: {
        title: '文明城市管理'
    }
}

